import React, { useContext } from 'react';
import { HubContext } from 'Redux/Context/context';
import { VegaGrid } from "@heartlandone/vega-react";
import FavoriteActivityListItem from 'Views/MyActivity/ActivityItem/Favorite';

function List() {
    const { globalActivitiesState } = useContext(HubContext);

    return (
        <VegaGrid column={3} row={2} gap={'size-16'}>
            {globalActivitiesState.activities?.map((activity, index) => {
                return <FavoriteActivityListItem key={activity.createdTime} activity={activity}/>;
            })}
        </VegaGrid>
    );
}

export default List;
